
import type { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import BrandPage from '../pages/brand/page';
import NewReleasesPage from '../pages/new-releases/page';
import CollectionsPage from '../pages/collections/page';
import ContactPage from '../pages/contact/page';
import AdminPage from '../pages/admin/page';
import AdminLoginPage from '../pages/admin/login/page';
import NotFound from '../pages/NotFound';

import BlogPage from '../pages/blog/page';
import BlogDetailPage from '../pages/blog/detail';
import ThankYouPage from '../pages/thank-you/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/golden-tower',
    element: <BrandPage />
  },
  {
    path: '/residences',
    element: <NewReleasesPage />
  },
  {
    path: '/amenities',
    element: <CollectionsPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
